export enum Token {
    TOKEN = 'env',
    REFRESH_TOKEN = 'APP_REFRESH_TOKEN',
}
